import React from 'react'
import { 
  MdStore, 
  MdInventory, 
  MdAttachMoney, 
  MdWarehouse,
  MdLocalOffer,
  MdLocalShipping,
  MdCardGiftcard,
  MdShoppingCart,
  MdPeople,
  MdBarChart,
  MdPayment,
  MdAssignment
} from 'react-icons/md'
import styles from './Features.module.scss'

const features = [
  { id: 'points', text: 'Торговые точки', icon: MdStore },
  { id: 'products', text: 'Товары', icon: MdInventory },
  { id: 'prices', text: 'Цены', icon: MdAttachMoney },
  { id: 'stocks', text: 'Остатки', icon: MdWarehouse },
  { id: 'promos', text: 'Акции', icon: MdLocalOffer },
  { id: 'delivery', text: 'Доставка', icon: MdLocalShipping },
  { id: 'loyalty', text: 'Бонусы', icon: MdCardGiftcard },
  { id: 'orders', text: 'Заказы', icon: MdShoppingCart },
  { id: 'staff', text: 'Персонал', icon: MdPeople },
  { id: 'analytics', text: 'Аналитика', icon: MdBarChart },
  { id: 'payments', text: 'Оплаты', icon: MdPayment },
  { id: 'projects', text: 'Проектные заказы', icon: MdAssignment },
]

export const Features: React.FC = () => {
  return (
    <div className={styles.grid}>
      {features.map(({ id, text, icon: Icon }) => (
        <div key={id} className={styles.card}>
          <Icon size={20} />
          <span>{text}</span>
        </div>
      ))}
    </div>
  )
}